import React from 'react';
import DashboardLayout from '../components/DashboardLayout';

const trainingWebinars = [
  {
    title: 'Admin & HR',
    schedule: 'Presented every Monday at 2 PM ET',
    audience: 'Owners and Administrators',
    goal: 'Understand how user accounts are created and different ways to customize the program. In this session you will Customize the Software Program for your agency. Please note this is a Live Data Base and Ivory Recommends you only use real time data, as opposed to fictitious patients or numbers. We realize it is sometimes necessary to do so for training purposes when actual data is not available. Please remember to take the time to go back and remove all non-essential information.',
    color: 'bg-[#5a9fcf]'
  },
  {
    title: 'Intake & Admissions',
    schedule: 'Presented every Tuesday at 2 PM ET',
    audience: 'Owners, Administrators, Intake Coordinators and Clinicians (such as Directors of Nursing, Clinical Managers)',
    goal: 'Ensure understanding of the Intake process (Demographic, Referral, and Admission). In this training session, if you have not already done so, you will enter a Patient Demographic. Then, you will continue to the Referral section, followed by Admission. Be sure to go through each item/tab under Patient in the demographics, referral and admission. Begin to think about your agency\'s workflow and who will be responsible for daily tasks.',
    color: 'bg-[#5a9fcf]'
  },
  {
    title: 'Nonskilled Assessment & Aide POC',
    schedule: 'Presented every Wednesday at 11 AM ET',
    audience: 'Owners, Administrators, Agency Program Supervisors',
    goal: null,
    goals: [
      'Complete Nonskilled Assessments Accurately',
      'Document the Aide Plan of Care (POC)',
      'Review how to select and update care tasks based on assessment findings and client needs'
    ],
    color: 'bg-[#5a9fcf]'
  },
  {
    title: 'OASIS & POC Plus',
    schedule: 'Presented every Wednesday at 2 PM ET',
    audience: 'Owners, Administrations, DONs, Clinical Managers, RNs',
    goal: null,
    goals: [
      'Navigate and use EMR tools to create and review OASIS',
      'Learn how to:',
      '• Analyze the OASIS',
      '• Create the POC Plus',
      '• Export OASIS'
    ],
    color: 'bg-[#5a9fcf]'
  },
  {
    title: 'Scheduling in Ivory',
    schedule: 'Presented every Thursday at 2 PM ET',
    audience: 'Owners, Administrator, Clinicians and Office Staff',
    goal: 'To schedule visits individually and in recurring series. Gain understanding of every aspect of the scheduling process in Ivory, and to convey the importance of using the scheduler and how it is tied to billing. Scheduling training is about tying it all together. In Ivory, visits that are preloaded into the system show for the caregivers so they may easily complete their visits.',
    color: 'bg-[#5a9fcf]'
  },
  {
    title: 'Navigating the Patient Chart',
    schedule: 'Presented every Friday at 2 PM ET',
    audience: 'Owners, Administrators, Clinicians, and Office Staff',
    goal: 'To Secure a clear understanding of all Patient Specific documents in the system and how they can be accessed from the Go To links in the Admission screen.',
    color: 'bg-[#5a9fcf]'
  },
  {
    title: 'Care Connect',
    schedule: 'Presented the 3rd Thursday of every month at 11 am ET',
    audience: 'Administrators, Office Managers, or other personnel with administrative responsibilities and oversight of CareConnect',
    goal: 'CareConnect is a module within Ivory that allows an agency to capture GPS, and use a clock in/out system for both skilled and nonskilled staff. CareConnect is also the piece for EVV capture. The class will cover: Staff (caregiver) Activation for CareConnect, Global settings for customization, Review of Aide Plan of Care, Demonstrating completion of CareConnect visits,* and the CareConnect Monitor, Conflicts Center and Conflicts resolution',
    color: 'bg-[#5a9fcf]'
  },
];

const LiveTrainingPage = () => {
  return (
    <DashboardLayout>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-light text-gray-700">
            Live Training <span className="text-gray-400 text-lg">» Webinar</span>
          </h1>
        </div>

        {/* Training Cards Grid */}
        <div className="grid grid-cols-3 gap-6 mb-6">
          {trainingWebinars.slice(0, 6).map((webinar, idx) => (
            <div key={idx} className="bg-white rounded-lg shadow-sm border overflow-hidden">
              {/* Header */}
              <div className={`${webinar.color} text-white p-4 text-center`}>
                <h3 className="font-semibold text-lg">{webinar.title}</h3>
                <p className="text-sm opacity-90 mt-1">{webinar.schedule}</p>
              </div>
              
              {/* Body */}
              <div className="p-4">
                <div className="mb-3">
                  <span className="font-semibold text-gray-700">Target Audience: </span>
                  <span className="text-gray-600 text-sm">{webinar.audience}</span>
                </div>
                
                <div className="mb-4">
                  <span className="font-semibold text-gray-700">Goal: </span>
                  {webinar.goal ? (
                    <span className="text-gray-600 text-sm">{webinar.goal}</span>
                  ) : (
                    <ul className="text-gray-600 text-sm mt-1 list-disc list-inside">
                      {webinar.goals?.map((g, i) => (
                        <li key={i} className={g.startsWith('•') ? 'ml-4 list-none' : ''}>
                          {g.replace('• ', '')}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                
                <button className="bg-[#3498db] hover:bg-[#2980b9] text-white px-6 py-2 rounded text-sm font-medium transition-colors">
                  Join
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Care Connect Card - Full Width */}
        <div className="bg-white rounded-lg shadow-sm border overflow-hidden mb-6">
          <div className={`${trainingWebinars[6].color} text-white p-4 text-center`}>
            <h3 className="font-semibold text-lg">{trainingWebinars[6].title}</h3>
            <p className="text-sm opacity-90 mt-1">{trainingWebinars[6].schedule}</p>
          </div>
          
          <div className="p-4">
            <div className="mb-3">
              <span className="font-semibold text-gray-700">Target Audience: </span>
              <span className="text-gray-600 text-sm">{trainingWebinars[6].audience}</span>
            </div>
            
            <div className="mb-4">
              <span className="font-semibold text-gray-700">Goal: </span>
              <span className="text-gray-600 text-sm">{trainingWebinars[6].goal}</span>
            </div>
            
            <button className="bg-[#3498db] hover:bg-[#2980b9] text-white px-6 py-2 rounded text-sm font-medium transition-colors">
              Join
            </button>
          </div>
        </div>

        {/* Note */}
        <div className="bg-gray-50 border rounded-lg p-4 mb-6">
          <p className="text-gray-700">
            <span className="font-semibold">Note:</span> If you are new to Ivory, we recommend that you complete the training sessions in the sequential order as they are presented.
          </p>
        </div>

        {/* Footer */}
        <div className="text-center text-gray-500 text-sm mt-8 pt-4 border-t">
          © 2026 Ivory Healthcare Systems, LLC. <span className="float-right">Version: 8.61.4.19</span>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default LiveTrainingPage;
